import PopinVideo from './popin-video';

export default class PopinVideoDesktop extends PopinVideo {
    constructor(...args) {
        super(...args);

        this.init();
    }
    init() {
        this.dom.close = this.dom.component.querySelector('.js-close-video');
    }

    bind() {
        let timeout;

        document.onmousemove = () => {
            TweenLite.to(this.dom.close, 0.4, {
                autoAlpha: 1,
                ease: Power3.easeOut,
            });
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                TweenLite.to(this.dom.close, 0.4, {
                    autoAlpha: 0,
                    ease: Power3.easeOut,
                });

            }, 3000);
        }
    }
    /*

    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/popin-video/popin-video.desktop.js